import { useCallback, useEffect, useState } from 'react';

import useSiteMetadata from './use_site_metadata';

function useCampaign() {
	const siteMetadata = useSiteMetadata();
	const [isActive, setIsActive] = useState(false);
	const [timeLeft, setTimeLeft] = useState();

	const endTime = siteMetadata?.config?.campaign_end_time;
	const startTime = siteMetadata?.config?.campaign_start_time;

	// Format endTime to YYYY-MM-DD
	const discount_valid_until = endTime
		? new Date(endTime).toISOString().split('T')[0]
		: null;

	const rawDiscount = siteMetadata?.config?.campaign_discount_amount;
	const discountCode = siteMetadata?.config?.campaign_discount_code || null;

	const parsedDiscount = parseFloat(rawDiscount);
	const discountAmount = !isNaN(parsedDiscount) ? `${parsedDiscount}%` : null;

	const image = siteMetadata?.config?.campaign_image || null;

	const calculateTimeLeft = useCallback(() => {
		const difference = new Date(endTime) - new Date();
		if (difference < 0 || !endTime) return null;

		return {
			days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
				2,
				'0',
			),
			hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
				2,
				'0',
			),
			minutes: String(Math.floor((difference / (1000 * 60)) % 60)).padStart(
				2,
				'0',
			),
			seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
		};
	}, [endTime]);

	useEffect(() => {
		let timer = null;

		if (isActive) {
			timer = setInterval(() => {
				setTimeLeft(calculateTimeLeft());
			}, 1000);
		}

		return () => clearInterval(timer);
	}, [calculateTimeLeft, isActive]);

	useEffect(() => {
		if (!endTime || !startTime) return;

		const now = new Date();
		const startDifference = new Date(startTime) - now;
		const endDifference = new Date(endTime) - now;

		setIsActive(startDifference <= 0 && endDifference >= 0);
	}, [endTime, startTime, timeLeft]);

	const isCampaignPageActive = siteMetadata?.config?.campaigns ?? false;

	return {
		discount: {
			amount: discountAmount,
			code: discountCode,
			valid_until: discount_valid_until,
		},
		image,
		isActive,
		isCampaignPageActive,
		timeLeft,
	};
}

export default useCampaign;
